// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modal overlay */
.upload-document-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* Modal content */
.upload-document-modal-content {
  background: #ffffff;
  border-radius: 1rem;
  width: 75vw;
  max-width: 75vw;
  height: 75vh;
  max-height: 75vh;
  display: flex;
  flex-direction: column;
  box-shadow:
    0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 20px 48px -8px rgba(0, 0, 0, 0.18);
  overflow: hidden;
}

/* Modal header */
.upload-document-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 1.75rem 1.25rem;
  border-bottom: 1px solid #f3f4f6;
}

.upload-document-modal-header h2 {
  margin: 0;
  color: #374151;
  font-size: 1.55rem;
  font-weight: 700;
  line-height: 1.3;
  letter-spacing: -0.01em;
}

.upload-document-modal-close {
  background: none;
  border: none;
  font-size: 2.4rem;
  color: #9ca3af;
  cursor: pointer;
  padding: 0;
  width: 2.4rem;
  height: 2.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  transition: color 0.15s;
  flex-shrink: 0;
}

.upload-document-modal-close:hover {
  color: #374151;
}

/* Form */
.upload-document-form {
  padding: 1.75rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  overflow-y: auto;
  flex: 1 1;
  min-height: 0;
}

/* Zone drag-and-drop */
.upload-dropzone {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 2.75rem 1.5rem 2.25rem;
  border: 2px dashed #e5e7eb;
  border-radius: 0.875rem;
  background: #f9fafb;
  text-align: center;
  transition:
    border-color 0.2s ease,
    background 0.2s ease,
    transform 0.15s ease;
  cursor: default;
  flex: 1 1;
}

.upload-dropzone--over {
  border-color: #f97316;
  background: #fff7ed;
  transform: scale(1.01);
}

.upload-dropzone--selected {
  border-color: #16a34a;
  background: #f0fdf4;
}

.upload-dropzone-icon {
  width: 60px;
  height: 60px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f97316;
  margin-bottom: 0.5rem;
  border: 1px solid #e5e7eb;
  background: #fff;
  /* box-shadow: 0 2px 8px rgba(249, 115, 22, 0.15); */
}

.upload-dropzone-icon svg {
  width: 30px;
  height: 30px;
}

.upload-dropzone-icon--ok {
  color: #16a34a;
  box-shadow: 0 2px 8px rgba(22, 163, 74, 0.15);
}

.upload-dropzone-label {
  margin: 0;
  font-size: 1.45rem;
  font-weight: 700;
  color: #1f2937;
  letter-spacing: -0.01em;
}

.upload-dropzone-sublabel {
  margin: 0.1rem 0;
  font-size: 1.15rem;
  color: #9ca3af;
  font-weight: 500;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.upload-dropzone-hint {
  margin: 0.25rem 0 0;
  font-size: 1.1rem;
  color: #9ca3af;
}

.upload-dropzone-filename {
  margin: 0;
  font-size: 1.35rem;
  font-weight: 700;
  color: #15803d;
  word-break: break-all;
  max-width: 90%;
}

.upload-dropzone-size {
  margin: 0;
  font-size: 1.2rem;
  color: #9ca3af;
}

.upload-dropzone-change {
  background: none;
  border: none;
  font-size: 1.2rem;
  color: #9ca3af;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;
  margin-top: 0.25rem;
  font-family: inherit;
  transition: color 0.15s;
}

.upload-dropzone-change:hover {
  color: #374151;
}

/* Error */
.upload-error-message {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-size: 1.3rem;
  color: #b91c1c;
  background: #fff1f2;
  border: 1px solid #fecdd3;
  border-radius: 0.625rem;
  padding: 0.875rem 1rem;
}

/* Actions */
.upload-document-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding-top: 0.25rem;
}

/* Responsive */
@media (max-width: 768px) {
  .upload-document-modal-content {
    width: 95%;
  }

  .upload-document-modal-actions {
    flex-direction: column-reverse;
  }
}
`, "",{"version":3,"sources":["webpack://./src/composants/UploadDocumentModal/UploadDocumentModal.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB;;wCAEsC;EACtC,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,UAAU;EACV,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,SAAO;EACP,aAAa;AACf;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,+BAA+B;EAC/B,0BAA0B;EAC1B,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB;;;wBAGsB;EACtB,eAAe;EACf,SAAO;AACT;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,UAAU;EACV,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;AACtB;;AAEA,eAAe;AACf;EACE;IACE,UAAU;EACZ;;EAEA;IACE,8BAA8B;EAChC;AACF","sourcesContent":["/* Modal overlay */\n.upload-document-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n/* Modal content */\n.upload-document-modal-content {\n  background: #ffffff;\n  border-radius: 1rem;\n  width: 75vw;\n  max-width: 75vw;\n  height: 75vh;\n  max-height: 75vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow:\n    0 4px 6px -1px rgba(0, 0, 0, 0.1),\n    0 20px 48px -8px rgba(0, 0, 0, 0.18);\n  overflow: hidden;\n}\n\n/* Modal header */\n.upload-document-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.5rem 1.75rem 1.25rem;\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.upload-document-modal-header h2 {\n  margin: 0;\n  color: #374151;\n  font-size: 1.55rem;\n  font-weight: 700;\n  line-height: 1.3;\n  letter-spacing: -0.01em;\n}\n\n.upload-document-modal-close {\n  background: none;\n  border: none;\n  font-size: 2.4rem;\n  color: #9ca3af;\n  cursor: pointer;\n  padding: 0;\n  width: 2.4rem;\n  height: 2.4rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n  transition: color 0.15s;\n  flex-shrink: 0;\n}\n\n.upload-document-modal-close:hover {\n  color: #374151;\n}\n\n/* Form */\n.upload-document-form {\n  padding: 1.75rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n}\n\n/* Zone drag-and-drop */\n.upload-dropzone {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 2.75rem 1.5rem 2.25rem;\n  border: 2px dashed #e5e7eb;\n  border-radius: 0.875rem;\n  background: #f9fafb;\n  text-align: center;\n  transition:\n    border-color 0.2s ease,\n    background 0.2s ease,\n    transform 0.15s ease;\n  cursor: default;\n  flex: 1;\n}\n\n.upload-dropzone--over {\n  border-color: #f97316;\n  background: #fff7ed;\n  transform: scale(1.01);\n}\n\n.upload-dropzone--selected {\n  border-color: #16a34a;\n  background: #f0fdf4;\n}\n\n.upload-dropzone-icon {\n  width: 60px;\n  height: 60px;\n  border-radius: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #f97316;\n  margin-bottom: 0.5rem;\n  border: 1px solid #e5e7eb;\n  background: #fff;\n  /* box-shadow: 0 2px 8px rgba(249, 115, 22, 0.15); */\n}\n\n.upload-dropzone-icon svg {\n  width: 30px;\n  height: 30px;\n}\n\n.upload-dropzone-icon--ok {\n  color: #16a34a;\n  box-shadow: 0 2px 8px rgba(22, 163, 74, 0.15);\n}\n\n.upload-dropzone-label {\n  margin: 0;\n  font-size: 1.45rem;\n  font-weight: 700;\n  color: #1f2937;\n  letter-spacing: -0.01em;\n}\n\n.upload-dropzone-sublabel {\n  margin: 0.1rem 0;\n  font-size: 1.15rem;\n  color: #9ca3af;\n  font-weight: 500;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n.upload-dropzone-hint {\n  margin: 0.25rem 0 0;\n  font-size: 1.1rem;\n  color: #9ca3af;\n}\n\n.upload-dropzone-filename {\n  margin: 0;\n  font-size: 1.35rem;\n  font-weight: 700;\n  color: #15803d;\n  word-break: break-all;\n  max-width: 90%;\n}\n\n.upload-dropzone-size {\n  margin: 0;\n  font-size: 1.2rem;\n  color: #9ca3af;\n}\n\n.upload-dropzone-change {\n  background: none;\n  border: none;\n  font-size: 1.2rem;\n  color: #9ca3af;\n  cursor: pointer;\n  text-decoration: underline;\n  padding: 0;\n  margin-top: 0.25rem;\n  font-family: inherit;\n  transition: color 0.15s;\n}\n\n.upload-dropzone-change:hover {\n  color: #374151;\n}\n\n/* Error */\n.upload-error-message {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  font-size: 1.3rem;\n  color: #b91c1c;\n  background: #fff1f2;\n  border: 1px solid #fecdd3;\n  border-radius: 0.625rem;\n  padding: 0.875rem 1rem;\n}\n\n/* Actions */\n.upload-document-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  padding-top: 0.25rem;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .upload-document-modal-content {\n    width: 95%;\n  }\n\n  .upload-document-modal-actions {\n    flex-direction: column-reverse;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
